module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('h1', {
    staticClass: "Poem-title",
    attrs: {
      "id": "_idParaDest-1",
      "lang": "en-GB"
    }
  }, [_vm._v("S"), _c('a', {
    attrs: {
      "id": "_idTextAnchor002"
    }
  }), _vm._v("ilent Beauties")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-first",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("The sun rose steadily in the distance,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("I sat as it illuminated the sky with its golden brilliance.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("The mountains stood tall and marvelled at his golden hue, while the sun")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("Painted them in it.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("I sat and watched in awe as wildlife sprang to life around me.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("The birds awoke and sang their songs")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("Of happiness and new beginnings, songs of joy")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("And adventure and songs of melancholy too.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("I sat and took in the smells of the morning air and the wonders of the sky,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("Striped with pastels.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("Blues, yellows, pinks and greys too.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("And I hoped that each day would have such")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("A brilliant positivity,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("But they never do;")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("And that’s what makes this day and this scenery a treasure,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("Because nothing will ever be identical to it.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c5d19208","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781035801855_EPUB-5.vue
// module id = 72
// module chunks = 0